import { db } from '../../config/firebaseconfig'

export default function fetchAllNodes(fetching, success, error) {
  fetching()
  db.collection('knowledgeMapNodes').get()
  .then((querySnapshot) => {
    let nodes = {}
    querySnapshot.forEach((doc) => {
      const data = doc.data()
      nodes[data.id] = data
    })
    success(nodes)
  })
  .catch((err) => error(err))
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/fetchAllNodes.js